import { OrganizationTeamResponseDto, PrismaWorkspaceDto } from 'app/API';

export const updateTeamWorkspaces = (
  teams: OrganizationTeamResponseDto[] | undefined,
  teamId: string,
  updateWorkspaces: (workspaces: PrismaWorkspaceDto[]) => PrismaWorkspaceDto[],
): OrganizationTeamResponseDto[] | undefined =>
  teams?.map((team) => (team.id === teamId ? { ...team, Workspaces: updateWorkspaces(team.Workspaces ?? []) } : team));
